import {useCustomQuery} from "../../../query/queryClient";
import {queryHttp} from "../../../query/queryHttp";
import {supplierEntityDetailUrl} from "../services/supplier360Urls";
import type {SupplierEntity} from "../types/Supplier360Types";

/** Single Supplier 360 entity by id (`GET supplier_360/entity/{id}/`). A 404 means "not found". */
export function useSupplierEntityQuery(entityId: string | undefined) {
    return useCustomQuery({
        queryKey: [supplierEntityDetailUrl(entityId ?? '')] as const,
        queryFn: async () => (await queryHttp.get<SupplierEntity>(supplierEntityDetailUrl(entityId as string))).data,
        enabled: Boolean(entityId),
        retry: false,
    });
}
